import { render, staticRenderFns } from "./OrganisationFamilyMemberList.vue?vue&type=template&id=5dcf9315&"
import script from "./OrganisationFamilyMemberList.vue?vue&type=script&lang=js&"
export * from "./OrganisationFamilyMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports